import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import backArrow from "../../../assets/images/navigate-back.svg";
import styles from "./index.module.scss";
import { Breadcrumbs, Typography } from "@mui/material";
import { highlightMahatriaAndInfinitheism } from "../HighlightMahatriaInfinitheism";

type BreadcrumbProps = {
  items: { label: string; path?: string }[];
  paddingProp ?: boolean; // Optional prop to control padding
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items , paddingProp = false}) => {
  const navigate = useNavigate();

  return (
    <div className={`${styles.breadcrumb} ${!paddingProp? styles.breadcrumbpadding : ""}`} >
      <img
        src={backArrow}
        alt=""
        className={styles.arrow}
        onClick={() => navigate(items[0].path || "/")}
      />
      <Breadcrumbs maxItems={2} aria-label="breadcrumb">
        {items.map((item, index) => {
          const isActive = item.label.includes("infinipath");
          console.log("item.path", isActive, item);
          if (item.path) {
            return (
              <Link
                key={index}
                to={item.path}
                className={`${styles.link} ${isActive ? styles.linkActive : ""}`}
              >
                {highlightMahatriaAndInfinitheism(item.label)}
              </Link>
            );
          } else {
            return (
              <Typography key={index} className={styles.linkActive}>
                {item.label}
              </Typography>
            );
          }
        })}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;
